/**
 * A person the CRM can point at.
 *
 * Deliberately minimal: the CRM does not own users, it references them. Anything
 * richer belongs to whatever the ERP already has.
 */

import { z } from 'zod'
import { uuid } from './common'

export const crmUser = z.object({
  id: uuid,
  name: z.string(),
  email: z.string().nullable(),
  /** Inactive users still resolve for existing records but cannot be picked. */
  active: z.boolean(),
})
export type CrmUser = z.infer<typeof crmUser>
